import React from 'react'

const IconMagnifyingGlass = ({
  className
}: {
  className: string
}): JSX.Element => {
  return (
    <svg
      className={className}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M51.3333 51.332L40.8333 40.832"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M23.3333 41.9993C33.6426 41.9993 42 33.642 42 23.3327C42 13.0234 33.6426 4.66602 23.3333 4.66602C13.024 4.66602 4.66663 13.0234 4.66663 23.3327C4.66663 33.642 13.024 41.9993 23.3333 41.9993Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M11.6666 23.3327C11.6666 20.2385 12.8958 17.271 15.0837 15.0831C17.2716 12.8952 20.2391 11.666 23.3333 11.666"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
    </svg>
  )
}

export default IconMagnifyingGlass
